import React, { useState } from "react";
import { db, auth } from "../firebase";
import { doc, setDoc } from "firebase/firestore";
import { useAuth } from "../context/AuthContext";
import toast from "react-hot-toast";

export default function ActivateAdmin() {
    const { user } = useAuth();
    const [loading, setLoading] = useState(false);

    async function handleActivate() {
        if (!user) {
            toast.error("You must be logged in first!");
            return;
        }
        setLoading(true);
        try {
            await setDoc(doc(db, "admins", user.uid), {
                email: user.email,
                role: "admin",
                activatedAt: new Date().toISOString()
            });
            toast.success("You are now an Admin! Refresh the page.");
        } catch (err) {
            console.error(err);
            toast.error("Failed to activate. Check Firestore rules.");
        }
        setLoading(false);
    }

    return (
        <div className="container" style={{ padding: "100px 20px", textAlign: "center", fontFamily: "'Inter', sans-serif" }}>
            <h1 className="section-title">Admin Activation</h1>
            <p style={{ color: "#666", marginBottom: 30 }}>
                This is a temporary tool to grant <strong>{user?.email || "your account"}</strong> admin privileges in Firestore.
            </p>
            {user ? (
                <button 
                    onClick={handleActivate} 
                    disabled={loading}
                    className="admin-btn-primary"
                    style={{ padding: "12px 32px", fontSize: 16 }}
                >
                    {loading ? "Activating..." : "Grant Me Admin Access"}
                </button>
            ) : (
                <p style={{ color: "#c0392b" }}>Please log in to the admin portal first, then return here.</p>
            )}
        </div>
    );
}
